/**
 * Job-candidate `source` values — where a candidate was added from.
 * Stored as free text by the backend (max 100 chars, not validated against
 * this list), so always use these constants to keep spelling consistent.
 * Only persisted when `already_applied` is true; otherwise it comes back null.
 */
export const CANDIDATE_SOURCE = {
  CHATBOT: 'chatbot',
  RESUME_UPLOAD: 'resume upload',
  INVITED_CANDIDATE: 'invited candidate',
  APPLY_PAGE: 'apply page',
  FACEBOOK_MESSENGER: 'facebook messenger',
  WHATSAPP: 'whatsapp',
  LINKEDIN: 'linkedin',
  VIBER: 'viber',
};

export const CANDIDATE_SOURCE_LABELS = {
  [CANDIDATE_SOURCE.CHATBOT]: 'Chatbot',
  [CANDIDATE_SOURCE.RESUME_UPLOAD]: 'Resume upload',
  [CANDIDATE_SOURCE.INVITED_CANDIDATE]: 'Invited candidate',
  [CANDIDATE_SOURCE.APPLY_PAGE]: 'Apply page',
  [CANDIDATE_SOURCE.FACEBOOK_MESSENGER]: 'Facebook Messenger',
  [CANDIDATE_SOURCE.WHATSAPP]: 'WhatsApp',
  [CANDIDATE_SOURCE.LINKEDIN]: 'LinkedIn',
  [CANDIDATE_SOURCE.VIBER]: 'Viber',
};

// Spelling variants the backend / channel bots may send, mapped to a canonical value.
const SOURCE_ALIASES = {
  messenger: CANDIDATE_SOURCE.FACEBOOK_MESSENGER,
  facebook: CANDIDATE_SOURCE.FACEBOOK_MESSENGER,
  fb: CANDIDATE_SOURCE.FACEBOOK_MESSENGER,
  'fb messenger': CANDIDATE_SOURCE.FACEBOOK_MESSENGER,
  'whats app': CANDIDATE_SOURCE.WHATSAPP,
  'linked in': CANDIDATE_SOURCE.LINKEDIN,
};

/** Canonical CANDIDATE_SOURCE value for a raw source string (case/separator-insensitive), or null. */
export const normalizeCandidateSource = (source) => {
  if (!source) return null;
  const key = String(source).trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  if (CANDIDATE_SOURCE_LABELS[key]) return key;
  return SOURCE_ALIASES[key] || null;
};

/** Display label for a candidate's source; "—" for null/empty. Unknown values are shown as-is. */
export const formatCandidateSource = (source) => {
  if (!source) return '—';
  return CANDIDATE_SOURCE_LABELS[normalizeCandidateSource(source)] || source;
};
